import {JSX, SVGProps} from "react";

import {downloadFichier} from "@/Api/fichier";
import IconContrat from "@/assets/iconContrat.svg?react";
import Loader from "@/components/Loader/Loader";
import {Contrat} from "@/ts/contrat";
import {Fichier} from "@/ts/fichier";

import {useLoadingState} from "../useLoadingState/useLoadingState";

type UseButtonToDownloadContratReturn = {
  label: string;
  icon:
    | JSX.Element
    | React.FunctionComponent<
        SVGProps<SVGSVGElement> & {
          title?: string;
        }
      >;
  title: string | undefined;
  variant: "negate" | "secondary";
  handleClick: () => Promise<void>;
};

export function useButtonToDownloadContrat({
  contrat,
  API,
  currentContremarque,
}: {
  contrat: Contrat;
  API: string;
  currentContremarque?: string;
}): UseButtonToDownloadContratReturn {
  const downloadContratLoadingState = useLoadingState();

  const label = downloadContratLoadingState.hasError
    ? "LE TELECHARGEMENT A ECHOUE RESSAYEZ"
    : "TELECHARGER LE CONTRAT";

  const icon = downloadContratLoadingState.isLoading ? (
    <Loader isIcon={true} color="white" />
  ) : (
    IconContrat
  );

  const title = downloadContratLoadingState.error ?? undefined;
  const variant = downloadContratLoadingState.hasError ? "negate" : "secondary";

  const handleClick = async (): Promise<void> => {
    downloadContratLoadingState.executeWithLoading(async () => {
      const fichierToDownload = contrat?.fichiers.find(
        (fichier: Fichier) => fichier.classe === "zip-contrat-signe"
      );

      if (fichierToDownload) {
        await downloadFichier(
          API,
          fichierToDownload.fichier_id,
          currentContremarque
        );
      } else {
        throw new Error("Aucun contrat signé trouvé");
      }
    });
  };

  return {label, icon, title, variant, handleClick};
}
